import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'

import { KirjanpitajanTiimi } from '../../_jaettu-lemonator/model/kirjanpitaja'
import { KirjanpitajanTiimiService } from '../../_jaettu-lemonator/service/kirjanpitajan-tiimi.service'
import { KirjautunutKayttajaService } from '../service/kirjautunut-kayttaja.service'

import { Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'

@Injectable()
export class TiimiGuard {
  constructor(
    private _router: Router,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _kirjanpitajanTiimiService: KirjanpitajanTiimiService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kipi => {
        const sallitutKirjanpitajat = route.data.sallitutKirjanpitajaUidt as [string]
        if (sallitutKirjanpitajat && kipi && sallitutKirjanpitajat.includes(kipi.uid)) {
          return Promise.resolve(true)
        }
        const sallitutTiimit = route.data.sallitutTiimit as [KirjanpitajanTiimi['avain']]
        if (sallitutTiimit && kipi) {
          return this._kirjanpitajanTiimiService.onkoKirjanpitajaJossakinTiimissa(kipi.uid, ...sallitutTiimit)
        }
        this._router.navigate(['/eioikeuksia'])
        return Promise.resolve(false)
      }),
    )
  }
}
